import {useColoreditStore} from "@km/components/color/colorEditStatusStore";
import {ColorAnimationVerwalter} from "@km/components/color/ColorAnimationVerwalter";
import {COLORMODULE_POSSIBLE_STATES} from "@km/components/color/ModuleColorAnimationStates";

export function closeAllLayersDownToAreaColorGroupings() {
    const statusStore = useColoreditStore();

    ColorAnimationVerwalter.setModuleColorState(
        COLORMODULE_POSSIBLE_STATES.areaColorGroupSelection
    );

    statusStore.reset();
}